<template>
    <div class="flex justify-between items-center border-b py-3" :class="[classBorder]">
        <div>
            <div class="text-14 text-a-brown-502314" v-if="getTextFix()">{{getTextFix()}}</div>
            <div class="text-14 text-a-brown-502314" v-else>Food order</div>
            <div class="text-12 text-a-brown-9f8273">{{getEarnDate(pointItem.Timestamp)}}</div>
        </div>
        <div class="point text-14 text-a-green-198737 text-right">
            + {{FilterNumberFormat(pointItem.points)}}
        </div>
    </div>
</template>
<script>
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: 'HistoryPointItem',
    mixins:[LocaleMixin],
    props: {
        pointItem: { type: Object, required: true },
        isLastItem: { type: Boolean, default: false },
    },
    computed: {
        isEarnPoint: function() {
            return this.pointItem.points >= 0;
        },
        classBorder: function () {
            if (this.isLastItem) {
                return 'border-transparent';
            }
            return 'border-a-brown-d7c7b8';
        },
    },
    data: function() {
        return {
            message: null,
            detail: null,
        };
    },
    created: function() {
        try {
            this.message = JSON.parse(this.pointItem.message);
        } catch (error) {
            console.log(error)
        }
        if (this.pointItem.detail) {
            try {
                this.detail = JSON.parse(this.pointItem.detail);
            } catch (error) {
                console.log(error);
            }
        }
    },
    methods: {
        getTextFix: function() {
            if (this.message) {
                if (this.message[0].Id == 'BurgerkingRegisterGetFreePoint') {
                    return Util.stringFormat(this.lbl.history.traces_msg,this.message[0].Points);
                } else {
                    if (this.detail == null) {
                        // string replace {point} with pointItem.points
                        return this.pointItem.detail.replace("{point}", Util.formatNum(this.pointItem.points));
                    } else { 
                        return null;
                    }
                }
            } else {
                if (this.detail == null) {
                    // string replace {point} with pointItem.points
                    return this.pointItem.detail.replace("{point}", Util.formatNum(this.pointItem.points));
                } else { 
                    return null;
                }
            }
        },
        getEarnDate: function(earnDate) {
            return DatetimeHelper.timestampFullFormat(earnDate,7) + " | " + DatetimeHelper.timeFormatShort2(earnDate,7);
        },

    }
}
</script>
<style lang="scss" scoped>
    .point {
        width: 45px;
    }
</style>
